import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_workshift_by_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { workshift_id: number }): 
  Promise<{ result: { Id?: number, Code?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, DurationMinutes?: number, Friday?: boolean, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Monday?: boolean, Name?: string, Saturday?: boolean, ShiftStartOffsetMinutes?: number, Sunday?: boolean, Thursday?: boolean, Tuesday?: boolean, WarehouseId?: number, Wednesday?: boolean } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workshift_id)) {
      missingRequiredInParams.push('\'workshift_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_workshift_by_id/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      workshift_id: number    }) {
        if(isNil(inParams.workshift_id)) {
          return true; 
        }
      return false;
    }
}
